'use client';

import Link from 'next/link';
import { ArrowRight } from 'lucide-react';
import { AuthAwareCTALink } from './AuthAwareCTALink';
import { appUrl } from '@/lib/config';
import { trackEvent } from '@/lib/analytics/events';

interface HeroCTAsProps {
  buttonText: string;
}

export default function HeroCTAs({ buttonText }: HeroCTAsProps) {
  const handleSecondaryClick = () => {
    trackEvent('cta_click', {
      cta_name: 'explore_editor',
      cta_location: 'hero_secondary',
      destination: appUrl('/editor/new'),
    });
    trackEvent('editor_opened', {
      source: 'hero_secondary',
    });
  };

  return (
    <div className="mb-10 flex flex-col items-center justify-center gap-4 sm:flex-row">
      {/* Thin client island — swaps href to /dashboard if already signed in */}
      <AuthAwareCTALink
        id="hero-cta-primary"
        ctaName="start_building_free"
        ctaLocation="hero_primary"
        className="group relative flex h-14 w-full items-center justify-center gap-2.5 overflow-hidden rounded-full bg-pb-blue-600 px-8 text-base font-bold text-pb-white shadow-lg shadow-pb-blue-600/20 transition-all duration-300 hover:-translate-y-0.5 hover:bg-pb-blue-700 hover:shadow-xl hover:shadow-pb-blue-600/40 sm:w-auto"
      >
        <span className="absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-pb-white/20 to-transparent transition-transform duration-1000 ease-in-out group-hover:translate-x-full" />
        <span className="relative z-10 flex items-center gap-2">
          {buttonText || 'Start Building Free'}
          <ArrowRight size={18} className="transition-transform group-hover:translate-x-1" />
        </span>
      </AuthAwareCTALink>
      <Link
        href={appUrl('/editor/new')}
        prefetch={false}
        id="hero-cta-secondary"
        onClick={handleSecondaryClick}
        className="group flex h-14 w-full items-center justify-center gap-2 rounded-full border border-pb-slate-200/90 bg-pb-white px-8 text-base font-bold text-pb-slate-800 shadow-sm backdrop-blur-md transition-all duration-300 hover:-translate-y-0.5 hover:border-pb-slate-300 hover:bg-pb-slate-50 hover:text-pb-slate-950 hover:shadow-md active:translate-y-0 sm:w-auto dark:border-pb-white/10 dark:bg-pb-white/5 dark:text-pb-slate-200 dark:hover:border-pb-white/20 dark:hover:bg-pb-white/10 dark:hover:text-pb-white"
      >
        <span>Explore the Editor</span>
        <ArrowRight size={18} className="transition-transform duration-300 group-hover:translate-x-1" />
      </Link>
    </div>
  );
}
